export default [
    {
        path: '/revocation/list',
        name: 'revocation_list',
        component: () => import('@src/revocation/revocation-list.vue'),
        meta: {
            title: 'Widerrufe',
            role: 'ROLE_REVOCATION',
        },
    },
    {
        path: '/revocation/open/list',
        name: 'revocation_open_list',
        component: () => import('@src/revocation/revocation-open-list.vue'),
        meta: {
            title: 'Offene Widerrufe',
            role: 'ROLE_REVOCATION',
        },
    },
    {
        path: '/revocation/create',
        name: 'revocation_create',
        component: () => import('@src/revocation/create-revocation.vue'),
        meta: {
            title: 'Widerruf erstellen',
            role: 'ROLE_REVOCATION',
        },
    },
    {
        path: '/revocation/edit/:id',
        name: 'revocation_edit',
        component: () => import('@src/revocation/edit-revocation.vue'),
        meta: {
            title: 'Widerruf bearbeiten',
            role: 'ROLE_REVOCATION',
        },
        props({ params }) {
            return {
                id: Number.parseInt(params.id),
            };
        },
    },
    {
        path: '/revocation/settings',
        name: 'revocation_settings',
        component: () => import('@src/revocation/settings/revocation-settings.vue'),
        meta: {
            title: 'Einstellungen Widerruf',
            role: 'ROLE_REVOCATION_SETTINGS',
        },
    },
    {
        path: '/revocation/search',
        name: 'revocation_search',
        component: () => import('@src/revocation/revocation-search.vue'),
        meta: {
            title: 'Widerruf suchen',
            role: 'ROLE_REVOCATION',
        },
    },
];
